import { useTranslation } from 'react-i18next';
import { RISK_COLOR } from './riskColor';
import type { IBriefingListProps } from './IBriefingListProps';

/** «Заперечення та наші відповіді» (прототип v4 ivObjs): крапка ризику, заперечення 600, «хто · ризик», «→ відповідь» зеленим, місток акцентом. */
export function BriefingObjections({ items, labels, onOpen }: IBriefingListProps) {
  const { t } = useTranslation();
  return (
    <section className="viz-card">
      <div className="viz-card__title">{t('recordPage.viz.briefing.objections')}</div>
      {items.map((r) => (
        <button key={r.id} type="button" className="viz-item" onClick={() => onOpen(r)}>
          <span className="viz-item__line"><i className="viz-item__dot" style={{ background: RISK_COLOR[String(r.values['risk'])] ?? '#64748b' }} /><strong>{r.title || r.display}</strong></span>
          <span className="viz-item__meta">{[r.values['who'], labels.option('risk', r.values['risk'])].filter(Boolean).join(' · ')}</span>
          <span className="viz-item__good">→ {r.values['answer'] ? String(r.values['answer']) : t('recordPage.viz.briefing.noAnswer')}</span>
          {r.values['bridge'] ? <span className="viz-item__bridge">{String(r.values['bridge'])}</span> : null}
        </button>
      ))}
    </section>
  );
}
